import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M20 4v16m-4 0h.01M12 20h.01M8 20h.01M4 20h.01M12 16h.01M4 16h.01M16 12h.01M12 12h.01M8 12h.01M4 12h.01M12 8h.01M4 8h.01M16 4h.01M12 4h.01M8 4h.01M4 4h.01"
    }, null, -1)
  ]))]))
}
export default { render: render }